angular
  .module('statBannerClicks')
  .component('statBannerClicks', {
    template: require('./stat-banner-clicks.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$location', '$translate', 'AuthService', 'envService',
      function StatBannerClicksController($rootScope, $scope, $resource, $location, $translate, AuthService, envService) {
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'bannerClicks';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        this.banners = [];
        this.totalClicks = 0;
        this.loading = false;
        this._poll = null;

        this.reload = (silent) => {
          if (!silent) {
            this.loading = true;
          }
          $resource(`${APIURL}/admin/services/apps/banners`)
            .get()
            .$promise
            .then((data) => {
              const list = (data.banners || []).map((b) => Object.assign({}, b, {
                click_count: Number(b.click_count) || 0,
              }));
              list.sort((a, b) => b.click_count - a.click_count);
              this.banners = list;
              this.totalClicks = list.reduce((sum, b) => sum + b.click_count, 0);
              this.loading = false;
            }, (err) => {
              this.loading = false;
              if (silent) {
                return;
              }
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.reload();
        this._poll = setInterval(() => this.reload(true), 5000);
        $scope.$on('$destroy', () => {
          if (this._poll) {
            clearInterval(this._poll);
            this._poll = null;
          }
        });
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/stat-banner-clicks/stat-banner-clicks.component.js